import React from "react";
import "./user-page.css";
import { useNavigate } from "react-router-dom";

const UserPage = () => {
  const navigate = useNavigate();

  const handleGoLogin = () => {
    navigate("/contact-us-details");
    window.location.reload();
  };

  return (
    <>
      <main className="user-page">
        <div className="our-container">
          <div className="inner-container">
            <div className="user-page-block">
              <h1>
                Thank You for accessing this page, but you do not have the
                required permissions.
              </h1>
              <button onClick={handleGoLogin} className="user-page-back-btn">
                Go to Login
              </button>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default UserPage;
